import { DynamicFormControlLayout, serializable } from '@ng-dynamic-forms/core';
import { BaseHaftpflichtSchadenModel, BaseHaftpflichtSchadenModelConfig } from '../shared-models/haftpflichtschaden.model';

export const TYPE_HAFTPFLICHT_TIERSCHADEN = 'HAFTPFLICHT-TIERSCHADEN';

export type HaftpflichtTierschadenModelConfig = BaseHaftpflichtSchadenModelConfig;

export class HaftpflichtTierschadenModel extends BaseHaftpflichtSchadenModel {
  @serializable() readonly type: string = TYPE_HAFTPFLICHT_TIERSCHADEN;

  constructor(config: HaftpflichtTierschadenModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
    // additional is set from super()
  }
}

// can be used like an enum:
export type GeschaedigtesTierVorhandenType = 'A' | 'N' | 'B';
export const GeschaedigtesTierVorhanden = {
  Erfassen:     'A',
  Nachgebracht: 'N',
  SieheBeilage: 'B',
  fromString(val: string): GeschaedigtesTierVorhandenType {
    return /^([ANB])$/.test(val) ? (val as GeschaedigtesTierVorhandenType) : null;
  }
} as const;
